module.exports = __webpack_public_path__ + "static/media/4x4no3.ffd0a7e4.jpg";